
import React from "react"
import PropTypes from "prop-types"

export const PlusIcon = ({ height = 16, width = 16, fill = "#272A34", ...props }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		fill='currentColor'
		{...props}
	>
		<path fillRule="evenodd" clipRule="evenodd" d="M16 7.536H8.464V0H7.536V7.536H0V8.464H7.536V16H8.464V8.464H16V7.536Z" />
</svg>
)

PlusIcon.propTypes = {
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	fill: PropTypes.string,
}





